/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// Generated stylesheet for ./labs/gb/styles/shape/md-shape-tokens.css.
import {css} from 'lit';
export const styles = css`/*!
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */@layer md.sys.shape{:root{--md-sys-shape-corner-none: 0px;--md-sys-shape-corner-xs: 4px;--md-sys-shape-corner-sm: 8px;--md-sys-shape-corner-md: 12px;--md-sys-shape-corner-lg: 16px;--md-sys-shape-corner-lg-increased: 20px;--md-sys-shape-corner-xl: 28px;--md-sys-shape-corner-xl-increased: 32px;--md-sys-shape-corner-xxl: 48px;--md-sys-shape-corner-full: 50cqmin}}
`;
export default styles.styleSheet!;
